import { render, staticRenderFns } from "./AllRequestList.vue?vue&type=template&id=24e78e00&lang=pug&"
import script from "./AllRequestList.vue?vue&type=script&lang=js&"
export * from "./AllRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports